export enum ConnectionPropertiesRejectedReason{
    GatewayNotSpecified = 1
}
